// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WYlF","badges":"styles_badges__2Hj3M"};